import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Title from "../../components/Title";
import GitHubIcon from "@mui/icons-material/Person";
import PaymentsIcon from "@mui/icons-material/Payment";
import Input from "../../components/Input";
import ButtonLoading from "../../components/ButtonLoading";

import { subtitle2 } from "../Login.style";
import Copyright from "../../components/Copyright";
import { colors } from "../../assets/colors";
import { loadStripe } from "@stripe/stripe-js";
import { USER_DATA } from "../../utils/constants";
import Row from "../../components/layout/Row";
import { getPayments } from "../../api/payments";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment-timezone";
import Loading from "../../components/Loading";

const stripePromise = loadStripe(
  "pk_test_51QoY7NE2yDzOSq6EqhcBoHF2JYc2uD1kIoP9S18K9ebNuWRl4OOLmFfG2XXpIHphw2pGKxv2UoCiOFXRUApYDkDX00fPn92ZWh"
); // Sua chave pública

// const stripePromise = loadStripe(
//   "pk_live_51QoY7NE2yDzOSq6E5Ppr1DUHkrhogJuD4s4aLIJvrdHK5A5RmB500TDpNZhzf3jx2C4v8Ff0AeSvKWGkHc47iPOe00oU0mtO4M"
// ); // Sua chave pública - PROD

interface Props {
  loading: boolean;
  githubToken: string;
  setGithubToken: (githubToken: string) => void;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  name: string;
  email: string;
  githubUser: string;
  setGithubUser: (githubUser: string) => void;
  password: string;
  setPassword: (password: string) => void;
  confirmPassword: string;
  setConfirmPassword: (confirmPassword: string) => void;
}

export default function ProfileScreen({
  loading,
  githubToken,
  setGithubToken,
  handleSubmit,
  name,
  email,
  githubUser,
  setGithubUser,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
}: Props) {
  const [status, setStatus] = useState("");
  const [payments, setPayments] = useState([]);
  const [paymentsLoading, setPaymentsLoading] = useState(false);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get(
      "session_id"
    );

    const checkPaymentStatus = async () => {
      const response = await fetch(
        "http://192.168.1.11:9000/check-payment-status",
        {
          method: "POST",
          body: JSON.stringify({ sessionId }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      console.log("result", result);
      setStatus(result.data.payment_status);
    };

    if (sessionId) {
      checkPaymentStatus();
    }
  }, []);

  useEffect(() => {
    setPaymentsLoading(true);
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    getPayments(JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid).then(
      (result: any) => {
        setPayments(result);
        setPaymentsLoading(false);
      }
    );
  };

  const handleCheckout = async () => {
    const response = await fetch(
      "http://192.168.1.11:9000/create-checkout-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // 📌 Definir o tipo de conteúdo como JSON
        },
        body: JSON.stringify({
          user: {
            email: email,
            user_uuid: JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid,
          },
          product: "price_1QoYePE2yDzOSq6E1NQyHcv6",
        }),
      }
    );
    const session = await response.json();

    // essa sessão será usada para o checkout
    // deve ser armazenada no banco amarrada com o usuario
    // para fazer a conciliação de pagamento
    console.log("sessão criada: ", session);

    // Redirecionando para o checkout do Stripe
    const stripe = await stripePromise;
    if (stripe) {
      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      if (result.error) {
        alert(result.error.message);
      }
    } else {
      console.error("Stripe has not been initialized.");
    }
  };

  const getStatus = (status: string) => {
    switch (status) {
      case "pago":
        return "✅ Pago";
      case "falhou":
        return "⚠️ Falhou";
      case "cancelado":
        return "🚨 Cancelado";
      default:
        return status;
    }
  };

  return (
    <Box sx={styles.container}>
      <Toolbar />
      <Box sx={{ margin: 4 }}>
        {/* <button onClick={handleCheckout}>{"Comprar Agora"}</button> */}

        <Row
          style={{
            height: "100%",
            alignItems: "flex-start",
            marginTop: 16,
            justifyContent: "center",
            gap: 50,
          }}
        >
          <Box component="form" onSubmit={handleSubmit} sx={styles.content}>
            <Title text="Profile" icon={<GitHubIcon color="primary" />} />

            <Box sx={{ width: "100%" }}>
              <span style={subtitle2}>
                Aqui você pode editar suas informações pessoais.
              </span>
            </Box>
            <Input
              title={"NOME"}
              placeholder={"Nome"}
              value={name}
              required
              disabled
            />
            <Input
              title={"E-MAIL"}
              placeholder={"E-mail"}
              value={email}
              autoComplete="email"
              required
              disabled
            />
            <Input
              title={"SENHA"}
              placeholder={"Senha"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              type="password"
              disabled
            />
            <Input
              title={"CONFIRMAR SENHA"}
              placeholder={"Confirmar senha"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              type="password"
              disabled
            />
            <Input
              title={"GITHUB TOKEN"}
              placeholder={"Inserir token"}
              value={githubToken}
              onChange={(e) => setGithubToken(e.target.value)}
              required
              type="password"
            />
            <Input
              title={"GITHUB USER"}
              placeholder={"Inserir token"}
              value={githubUser}
              onChange={(e) => setGithubUser(e.target.value)}
            />
            <ButtonLoading label="Editar cadastro" loading={loading} />
          </Box>

          <Box sx={styles.content}>
            <Title text="Pagamentos" icon={<PaymentsIcon color="primary" />} />
            <Box sx={{ width: "100%" }}>
              <span style={subtitle2}>
                Aqui você pode editar suas informações pessoais.
              </span>
            </Box>
            {status == "paid" && (
              <Box
                sx={{
                  marginTop: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 2,
                  backgroundColor: "#E5FFE6C6",
                  borderRadius: 2,
                  border: "3px solid #00D807CE",
                }}
              >
                <span style={{ color: colors.black, fontWeight: 500 }}>
                  {status} ✅ Pagamento realizado com sucesso!
                </span>
              </Box>
            )}{" "}
            {status == "unpaid" && (
              <Box
                sx={{
                  marginTop: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 2,
                  backgroundColor: "#FFFDE5C6",
                  borderRadius: 2,
                  border: "3px solid #FFF200CE",
                }}
              >
                <span style={{ color: colors.black, fontWeight: 500 }}>
                  ⚠️ Pagamento não realizado!
                </span>
              </Box>
            )}
            <TableContainer sx={{ mt: 2 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ backgroundColor: colors.background }}>
                    <TableCell
                      align="center"
                      sx={{ backgroundColor: colors.background }}
                    >
                      Data
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ backgroundColor: colors.background }}
                    >
                      Valor
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ backgroundColor: colors.background }}
                    >
                      Situação
                    </TableCell>
                  </TableRow>
                </TableHead>

                {paymentsLoading && <Loading text="Carregando pagamentos..." />}

                {!paymentsLoading && (
                  <TableBody>
                    {payments &&
                      payments.length > 0 &&
                      payments.map((payment: any) => (
                        <TableRow key={payment.id}>
                          <TableCell align="center">
                            {moment(payment.createdAt.toDate())
                              .tz("America/Sao_Paulo")
                              .format("DD/MM/YYYY HH:mm:ss")}
                          </TableCell>
                          <TableCell align="center">
                            {payment.amount_paid &&
                              (payment.amount_paid / 100).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )}
                          </TableCell>
                          <TableCell align="center">
                            {getStatus(payment.status)}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Box>
        </Row>
        <Copyright />
      </Box>
    </Box>
  );
}

const styles = {
  container: {
    backgroundColor: colors.white,
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    width: "46%",
    justifyContent: "start",
  },
};
